export default __webpack_public_path__ + "static/media/42.5a6d62ef.jpeg";